import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";

const AddTransactionItemAPI = async (data) => {
  const url = APIURL + "/schema/addTransactionItemsNew";
  const user = useAuth();
  return await axios.post(url, { access_token: user.token, ...data });
};

export default AddTransactionItemAPI;
